<section class="is-widescreen">
    <h1 class="title">
        Nutzer hinzufügen
    </h1>
    <h2 class="subtitle">
        Fügen Sie einer bestehenden Nutzergruppe einen weiteren Nutzer hinzu
    </h2>
    <div class="container is-fullwidth">
        <div class="notification is-info is-fullwidth" style="padding: 1.25rem 1.5rem 1.25rem 1.5rem !important;">
            <div class="field is-fullwidth">
                <label class="label">Neuer Nutzer</label>
                <div class="control has-icons-left">
                    <input class="input is-rounded" style="margin-left: 0 !important; margin-right: 0 !important" placeholder="E-Mail Adresse" [(ngModel)]="this.mail">
                    <span class="icon is-small is-left">
                    <mat-icon class="fas">email</mat-icon>
                </span>
                </div>
            </div>
            <div class="field is-fullwidth">
                <label class="label">Nutzergruppe auswählen</label>
                <div class="control">
                    <div class="select is-rounded is-fullwidth">
                        <select #selection (change)="this.selectGroup(selection.value)">
                            <option *ngFor="let group of dialogData.groups">{{group.userGroup.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="hero-foot">
    <footer class="card-footer">
        <a class="card-footer-item cancel" (click)="cancel()">Abbrechen</a>
        <a class="card-footer-item save" (click)="save()">Speichern</a>
    </footer>
</div>
